import { Kit } from '@repo/types';
import useFeature from 'services/features/useFeature';

const FIRST_LOOK_CUTOFF_DATE_DEFAULT = '2026-04-09';

export interface FirstLookFeature {
  enabled: boolean;
  cutoffDate?: Date;
}

export interface FirstLookFeatureFlags {
  cutoffDate?: Date;
}

export const useFirstLookFeature = (featureName: string): FirstLookFeature => {
  const ff = useFeature(featureName);
  const cutoffDate = ff.variables?.cutoff_date;
  return {
    enabled: ff.isFeatureEnabled,
    cutoffDate: cutoffDate ? new Date(cutoffDate) : undefined,
  };
};

export const shouldShowFirstLook = (
  kit: Kit | undefined,
  featureFlags: FirstLookFeatureFlags,
): boolean => {
  if (!kit) return false;

  if (!kit.date_results_ready) return false;
  const resultsReadyDate = new Date(kit.date_results_ready);

  const cutoffDate =
    featureFlags.cutoffDate || new Date(FIRST_LOOK_CUTOFF_DATE_DEFAULT);
  return resultsReadyDate >= cutoffDate;
};
